import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';

import { Provider } from 'react-redux';

import React from 'react';

import ReactDOM from 'react-dom/client';

import { AppContainer } from 'react-hot-loader';
import { PersistGate } from 'redux-persist/integration/react';

import App from '../main/app';
import { combinePackages } from './combine-packages';
import { initStore } from './init-store';
import pkgs from './packages';
import { importStack } from './set-up-env';

const { reducers, modals, sagas } = combinePackages(pkgs);

const root = ReactDOM.createRoot(document.getElementById('root'))

export const load = async (config) => {
  await importStack();
  const {
    isPublic,
    filters,
    subunits = [],
    layers,
    city,
    reports = [],
    state,
    defaultZipcode,
    type,
    center,
    information = '*No information about this project.*',
    defaultSidebar = null,
    zoom,
    navigation = [],
    customLayersConfig = {},
    sidebarFlags,
    mapHoverProps,
    mapHoverFilters,
    canSignUp,
  } = config;

  if (isPublic) {
    window.serverConfig.namespace = `public/${window.serverConfig.namespace}`;
  }

  const start = () => {
    const { store, persistor } = initStore(
      { reducers, sagas, modals },
      {
        isPublic,
        navigation,
        city,
        canSignUp,
        state,
        information,
        defaultSidebar,
        subunits,
        reports,
        defaultZipcode,
        moduleType: type,
        serverConfig: window.serverConfig,
        imgRoute: window.imgRoute,
        accordian: layers,
        filters,
        customLayersConfig,
        sidebarFlags,
        mapHoverProps,
        mapHoverFilters,
        mapSettings: {
          MAIN_MAP: {
            center,
            zoom,
          },
        },
      },
    );

    return root.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppContainer>
            <App modals={modals} />
          </AppContainer>
        </PersistGate>
      </Provider>,
    );
  };

  start();

  // This is needed for Hot Module Replacement
  if (module.hot) {
    module.hot.accept('../../packages/main/app', start);
  }
};
